(function () {
  'use strict';
  document.querySelectorAll('.vicca-pdp-catalog').forEach(function (root) {
    var form = root.closest('form');
    if (!form || root.dataset.catalogReady) return;
    root.dataset.catalogReady = 'true';
    var link = root.querySelector('[data-vicca-catalog-quote]');
    var productNode = root.querySelector('.vicca-product-options__json');
    var variants = [];
    try { variants = JSON.parse(productNode.textContent).variants || []; } catch (error) {}
    var previousQuantity = Math.max(1, parseInt(form.querySelector('[name="quantity"]')?.value, 10) || 1);
    function update() {
      var field = form.querySelector('[name="id"]');
      var selected = variants.find(function (variant) { return String(variant.id) === String(field && field.value); });
      var quantity = Math.max(1, parseInt(form.querySelector('[name="quantity"]')?.value, 10) || 1);
      if (quantity !== previousQuantity) {
        previousQuantity = quantity;
        if (typeof window.viceQtyChanged === 'function') window.viceQtyChanged(quantity);
      }
      var minus = root.querySelector('.js-qty__adjust--minus');
      var plus = root.querySelector('.js-qty__adjust--plus');
      var label = root.querySelector('.vicca-pdp-catalog__quantity-label');
      if (minus && label) minus.setAttribute('aria-label', label.textContent.trim() + ' −');
      if (plus && label) plus.setAttribute('aria-label', label.textContent.trim() + ' +');
      var comparison = root.querySelector('.product-price .enj-product-price-compare');
      if (selected && !comparison && Number(selected.compare_at_price) > Number(selected.price)) {
        var price = root.querySelector('.product-price .engoj_price_main');
        if (price) {
          comparison = document.createElement('del');
          comparison.className = 'enj-product-price-compare';
          price.before(comparison, document.createTextNode(' '));
        }
      }
      if (comparison && selected) {
        comparison.hidden = !(Number(selected.compare_at_price) > Number(selected.price));
        if (!comparison.hidden) comparison.textContent = new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(Number(selected.compare_at_price) / 100);
      }
      if (!link) return;
      var url = new URL(link.dataset.productUrl);
      if (field && field.value) url.searchParams.set('variant', field.value);
      var lines = [link.dataset.message];
      if (selected && selected.title !== 'Default Title') lines.push(link.dataset.configurationLabel + ': ' + selected.title);
      root.querySelectorAll('.vicca-accessory-select').forEach(function (select) {
        if (!select.value) return;
        var option = select.options[select.selectedIndex];
        var value = option.dataset.name || option.textContent.trim();
        lines.push(select.dataset.group + ': ' + value);
      });
      lines.push(link.dataset.quantityLabel + ': ' + quantity, url.href);
      link.href = 'https://wa.me/56991089527?text=' + encodeURIComponent(lines.join('\n'));
    }
    form.addEventListener('change', function () { window.setTimeout(update, 0); });
    form.addEventListener('input', function () { window.setTimeout(update, 0); });
    form.addEventListener('click', function () { window.setTimeout(update, 100); });
    if (link) {
      link.addEventListener('focus', update);
      link.addEventListener('click', update);
    }
    window.addEventListener('load', update, { once: true });
    update();
  });
})();
